// Module
var code = `<div data-bind="class: \$data.item.css">
    <!-- ko if: \$data.item.needSeparator && !\$data.creator.toolbox.showCategoryTitles-->
    <div class="svc-toolbox__category-separator"></div>
    <!-- /ko -->
    <div class="svc-toolbox__tool-content sv-action__content" data-bind="event: { pointerdown: (model, event)=>{onPointerDown(event); return true;} }">
        <!-- ko component: { name: \$data.itemComponent, params: { model: \$data, item: \$data.item, creator: \$data.creator, isCompact: \$data.isCompact } } -->
        <!-- /ko -->
    </div>
</div>`;
// Exports
export default code;